import SettingConfig from '../config/setting';

export const checkIsMobile = () => {
  if (SettingConfig.ENVIRONMENT.includes('m-')) return true;
  if (typeof window !== 'undefined' && window.location.hash === '#mobile') return true;
  return false;
};
